import { cloneElement } from "react";

import { Box, BoxProps, ListProps, Text } from "@vinomofo/components";
import { ReturnsIcon, TagIcon } from "@vinomofo/icons";
import styled from "styled-components";

import type { ResponsiveValue } from "../../types";

export interface OfferSellingPointsProps extends ListProps {
  isSpirit?: boolean;
  isAvailable?: boolean;
  returnsDisplay?: ResponsiveValue<string>;
  tagDisplay?: ResponsiveValue<string>;
  horizontal?: boolean;
  withBG?: boolean;
}

const SellingPoint = ({
  icon,
  label,
  color,
  ...rest
}: {
  icon: JSX.Element;
  label: string;
} & BoxProps): JSX.Element => {
  return (
    <Box
      display="flex"
      alignItems="flex-start"
      flexDirection={["column", "column", "row"]}
      px="20px"
      {...rest}
    >
      <Box
        color="brand"
        width="20px"
        height="20px"
        marginRight="0.5em"
        position="relative"
      >
        {cloneElement(icon, { size: "20px" })}
      </Box>
      <Text as="span" color="darkMofo" fontSize={["12px", "12px", "14px"]}>
        {label}
      </Text>
    </Box>
  );
};

const SellingPointContainer = styled(Box)`
  background: white;
  width: 690px;
  margin: 0 auto;
  padding: 5px 10px 5px 0;
  border-radius: 5px;
`;

const SellingPointWrapper = styled(Box)`
  @media ${({ theme }) => theme.mq.max.mobile} {
    display: none;
  }
`;

export const OfferSellingPoints = ({
  isSpirit,
  isAvailable = true,
  withBG,
  ...rest
}: OfferSellingPointsProps): JSX.Element | null => {
  const content = (
    <>
      {!isSpirit && (
        <SellingPoint
          icon={<ReturnsIcon />}
          borderRight="1px solid"
          borderColor="divider"
          color={"white"}
          label="Don’t like me? No problem, free returns!"
        />
      )}
      <SellingPoint
        icon={<TagIcon />}
        label="You won’t find me cheaper anywhere else!"
        color={"white"}
        paddingRight="0"
      />
    </>
  );
  return isAvailable ? (
    <SellingPointWrapper py="20px" justifyContent="center" {...rest}>
      {withBG ? (
        <SellingPointContainer
          fontSize={[0, 1]}
          fontWeight="500"
          color="text.heading"
          letterSpacing="tight"
          display="flex"
          alignItems={["flex-start", "center"]}
          justifyContent="center"
        >
          {content}
        </SellingPointContainer>
      ) : (
        <Box
          fontSize={[0, 1]}
          fontWeight="500"
          color="text.heading"
          letterSpacing="tight"
          display="flex"
          alignItems={["flex-start", "center"]}
          justifyContent="center"
        >
          {content}
        </Box>
      )}
    </SellingPointWrapper>
  ) : (
    <Box minHeight={[0, 135]} {...rest} />
  );
};
